/**
 * removes the element from the array only if the element occurs in the array
 * @param {*} array
 * @param {*} element
 */
export function removeElement<T>(array: Array<T>, element: T): void {
  let index: number = array.indexOf(element);
  if (index > -1) {
    array.splice(index, 1);
  }
}

/**
 * @param {*} string
 * @returns The string but with all spaces replaced with _
 */
export function rmSpaces(string: string): string {
  return string.replace(' ', '_');
}

/**
 * @param {*} string - string in any format, snake case, camel case, or with spaces
 * @returns - string converted to snake case, with no special characters
 */
export function toSnakeCase(str: string): string {
  str = str.replaceAll('-', '_');
  str = str.replace(/[^a-zA-Z0-9_ ]/g, ''); // remove special characters
  str = str.replace(/\s+/g, '_');
  str = str.replace(/([a-z])([A-Z])/g, '$1_$2');
  str = str.replace(/_([0-9])/g, '$1');
  str = str.toLowerCase();
  return str;
}

/**
 * @param {*} string - string in any format, snake case, camel case, or with spaces
 * @returns - string converted to camel case, with no special characters
 */
export function toCamelCase(str: string): string {
  str = str.replace(/[^a-zA-Z0-9_ ]/g, ''); // remove special characters
  str = str.replaceAll('_', ' ');
  return str.replace(/ (\w)/g, function (match, letter: string) {
    return letter.toUpperCase();
  });
}

/**
 * @param {*} string - string in any format, snake case, camel case, or with spaces
 * @returns - string converted to pascal case, with no special characters
 */
export function toPascalCase(str: string): string {
  str = str.replace(/[^a-zA-Z0-9_ ]/g, ''); // remove special characters
  str = str.replaceAll('_', ' ');
  return str
    .match(
      /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
    )!
    .map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
    .join('');
}

/**
 * @param {*} string - string in any format, snake case, camel case, or with spaces
 * @returns - string converted to git repo name format, which is but with dashes instead of underscore
 */
export function toGitRepoName(str: string): string {
  str = toSnakeCase(str);
  str = str.replaceAll('_', '-');
  return str;
}

/**
 * Gets the index of the last character of the substring in the search string
 * @param searchStr
 * @param subStr
 * @returns
 */
export const getLastIndexOf = (searchStr: string, subStr: string) => {
  return searchStr.indexOf(subStr) + subStr.length;
};

/**
 * TODO: change in release to 8000
 * @returns
 */
export const getURL = () => {
  return window.location.href.slice(0, 21);
};
